import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
 const [user, setUser] = useState(undefined); // undefined=loading, null=anon, {}=user

 useEffect(() => {
 // Probe session via httpOnly cookie. Token may also still be in localStorage
 // (older flows); the api interceptor will attach it as a Bearer header.
 api.get("/auth/me")
 .then((r) => setUser(r.data))
 .catch(() => { localStorage.removeItem("gls_token"); setUser(null); });
 }, []);

 async function login(email, password) {
 const { data } = await api.post("/auth/login", { email, password });
 // Cookie is set httpOnly by the server. We also retain the token in
 // localStorage as a Bearer fallback for environments without 3rd-party cookies.
 if (data?.access_token) localStorage.setItem("gls_token", data.access_token);
 setUser(data.user);
 return data.user;
 }

 async function logout() {
 try { await api.post("/auth/logout"); } catch (e) { /* noop */ }
 localStorage.removeItem("gls_token");
 setUser(null);
 }

 return (
 <AuthContext.Provider value={{ user, login, logout }}>
 {children}
 </AuthContext.Provider>
 );
}

export function useAuth() {
 return useContext(AuthContext);
}
